// extracted by mini-css-extract-plugin
export default {"container":"SearchError_container__J1GhR"};